<template>
<div>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>

  <div class="row" >
    <div class="col">
      <card class="no-scrollbar" style="overflow-x: scroll">
        <div class="row mb-3">
          <div class="col">
            <div
              class="btn-group btn-group-toggle"
              :class="'float-left'"
              data-toggle="buttons"
            >
              <label
                v-for="(option, index) in categories"
                :key="index + j"
                class="btn btn-sm btn-primary btn-simple"
                :class="{ active: option.active }"
                :id="index"
              >
                <input
                  type="radio"
                  @click="switchTab(index)"
                  name="options"
                  autocomplete="off"
                  :checked="option.active"
                />
                <span style="font-size: medium; font-weight: lighter">{{ option.name }}</span>

              </label>
            </div>
          </div>

          <div class="col-auto ml-auto text-right" v-if="hasPermissions('inventory_create')">
            <base-button v-if="activeTabIndex === 0" size="sm" v-on:click="addItem()" type="primary" >
              <i class="tim-icons icon-simple-add mr-2"></i> Add new item</base-button>
            <base-button v-if="activeTabIndex === 1" size="sm" v-on:click="addNewItemCategory()" type="primary" >
              <i class="tim-icons icon-simple-add mr-2"></i> Add new item category</base-button>
          </div>
        </div>

        <div v-if="activeTabIndex === 0">
          <filter-bar
            :filters="filterSchema"
            :initial-value="filterValues"
            :result-count="totalRows"
            :loading="tableLoading"
            :per-page="perPage"
            :per-page-options="perPageOptions"
            saved-filters-key="inventory"
            @change="onFiltersChanged"
            @update:perPage="onPerPageChange"
          >
            <template #actions>
              <base-button v-if="hasPermissions('download_data')" icon class="btn-link text-white" v-on:click="downloadCSV()">
                <i class="tim-icons icon-cloud-download-93"></i>
              </base-button>
            </template>
          </filter-bar>

          <div v-if="items.length <= 0" class="mt-3" >
            <div class="font-icon-detail">
            <span style="font-size: 3em">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
              <h4 class="mt-3">No items have been created yet.</h4>
            </div>
          </div>

          <!--        Desktop-->
          <div class="d-none d-sm-block">
            <div class="row" >
              <div class="col">
                <b-table v-if="items.length > 0" striped hover :items="items"
                         :fields="itemFields"
                         no-local-sorting
                         :busy="tableLoading"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         @sort-changed="onSortChanged">
                  <template #table-busy>
                    <div class="text-center my-4">
                      <i class="el-icon-loading" style="color: #e14eca; font-size: 18px;"></i>
                      <span class="ml-2 text-white">Loading</span>
                    </div>
                  </template>
                  <template #head(is_an_add-on)="data">
                    <div style="white-space: nowrap;">is an add-on</div>
                  </template>
                  <template #head(availability)="data">
                    <div style="white-space: nowrap;">sellable on</div>
                  </template>
                  <template #head(unit_price)="data">
                    <div style="white-space: nowrap;">unit price</div>
                  </template>
                  <template #head(purchase_limit)="data">
                    <div style="white-space: nowrap;">purchase limit</div>
                  </template>
                  <template v-slot:cell(unit_price)="row">
                    <div>{{getAmount(row.item.price)}}</div>
                  </template>
                  <template v-slot:cell(available)="row">
                    <badge v-if="row.item.unlimited_available_quantity" type="default">unlimited</badge>
                    <span v-else>{{row.item.available}}</span>
                  </template>
                  <template v-slot:cell(purchase_limit)="row">
                    <badge v-if="!row.item.enforce_purchase_limit" type="default">none</badge>
                    <span v-else>{{row.item.max_purchase_quantity}}</span>
                  </template>
                  <template v-slot:cell(item_name)="row">
                    <div >
                      <img v-if="row.item.img && row.item.img.url" class="item-thumb" :src="row.item.img.url"/>
                      <div v-else class="item-thumb item-thumb--empty">
                        <i class="tim-icons icon-image-02"></i>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div>
                          {{row.item.name}}
                        </div>
                        <div>
                          <small>{{row.item.description}}</small>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(category)="row">
                    <badge v-if="row.item.category_name">{{row.item.category_name}}</badge>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:cell(availability)="row">
                    <badge v-if="row.item.sellable_external" type="success">Booking site</badge>
                    <badge v-if="row.item.sellable_internal" type="info">Internal</badge>
                    <badge v-if="!row.item.sellable_internal && !row.item.sellable_external" type="default">Not for sale</badge>
                  </template>
                  <template v-slot:cell(is_an_add-on)="row">
                    <i v-if="row.item.is_addon" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.is_addon" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        link
                        type="primary"
                        size="sm"
                      > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a v-if="hasPermissions('inventory_update')" class="dropdown-item mt-1 mb-2" v-on:click="editItemPrompt(row.item)">
                            <i class="tim-icons text-warning icon-pencil mr-2"></i> Edit item
                          </a>
                          <a class="dropdown-item mt-1 mb-2" href="#" v-if="hasPermissions('inventory_update')"
                             v-on:click="copyToGroupsPrompt(row.item, $event)">
                            <i class="tim-icons text-default icon-single-copy-04 mr-2"></i> Copy to other groups
                          </a>
                          <hr v-if="hasPermissions('inventory_update') && hasPermissions('inventory_delete')">
                          <a v-if="hasPermissions('inventory_delete')" class="dropdown-item mt-1 mb-2"  v-on:click="deleteItemPrompt(row.item)">
                            <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Delete item
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

<!--          Mobile-->
          <div class="d-block d-sm-none">
            <div class="row" >
              <div class="col">
                <b-table v-if="items.length > 0" striped hover :items="items"
                         :fields="['items']">
                  <template v-slot:cell(items)="row">
                    <div class="row">
                      <div class="col">
                        <div>
                          <h4 class="card-title">{{row.item.name}} </h4>
                        </div>
                      </div>
                      <div class="col text-right">
                        <badge type="success" v-if="row.item.sellable_external">Booking site</badge>
                        <badge type="info" v-if="row.item.sellable_internal">Internal</badge>
                        <badge type="default" v-if="!row.item.sellable_internal && !row.item.sellable_external">Not for sale</badge>
                        <badge>{{row.item.category_name}}</badge>
                      </div>
                    </div>
                    <div>
                      <small>{{row.item.description}}</small>
                    </div>
                    <p>Unit price: {{getAmount(row.item.price)}}</p>
                    <p>Available:
                      <badge class="ml-1" type="default" v-if="row.item.unlimited_available_quantity">unlimited</badge>
                      <span v-else>{{row.item.available}}</span>
                    </p>
                    <p>Purchase limit:
                      <badge class="ml-1" type="default" v-if="!row.item.enforce_purchase_limit">none</badge>
                      <span v-else>{{row.item.max_purchase_quantity}}</span>
                    </p>
                    <p>Purchased: {{row.item.purchased}}</p>

                    <div
                      class="btn-group btn-group-toggle mt-3 mb-2"
                      :class="'float-left'"
                      data-toggle="buttons" style="width:100%"
                    >
                      <label class="btn btn-sm btn-primary btn-simple" v-if="hasPermissions('inventory_update')">
                        <base-button
                          v-on:click="editItemPrompt(row.item)"
                          type="primary"
                          class="btn btn-link"
                          size="sm"
                          icon
                        ><i class="tim-icons icon-pencil"></i>
                        </base-button>
                      </label>
                      <label class="btn btn-sm btn-primary btn-simple" v-if="hasPermissions('inventory_delete')">
                        <base-button
                          v-on:click="deleteItemPrompt(row.item)"
                          type="primary"
                          class="btn btn-link"
                          size="sm"
                          icon
                        ><i class="tim-icons icon-trash-simple"></i>
                        </base-button>
                      </label>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            v-on:input="getItems(perPage, getOffset(currentPage, perPage))"
          ></b-pagination>
        </div>

        <div v-if="activeTabIndex === 1">
          <div class="d-block d-sm-none">
            <div class="row">
              <div class="col" v-if="hasPermissions('inventory_create')">
                <base-button v-if="activeTabIndex === 1" size="sm" v-on:click="addNewItemCategory()" type="primary" >
                  <i class="tim-icons icon-simple-add mr-2"></i> Add new item category</base-button>
              </div>
            </div>
          </div>

          <div v-if="item_categories.length <= 0" class="mt-3" >
            <div class="font-icon-detail">
            <span style="font-size: 3em">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
              <h4 class="mt-3">No item categories have been created yet.</h4>
            </div>
          </div>

          <!--        Desktop-->
          <div class="d-none d-sm-block">
            <div class="row" >
              <div class="col">
                <b-table v-if="item_categories.length > 0" striped hover :items="item_categories"
                         :fields="['category_name', 'actions']">
                  <template v-slot:cell(category_name)="row">
                    <div>{{row.item.name}}</div>
                    <small>{{row.item.description}}</small>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        link
                        type="primary"
                        size="sm"
                      > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                      </base-button>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <a v-if="hasPermissions('inventory_update')" class="dropdown-item mt-1 mb-2" v-on:click="editItemCategoryPrompt(row.item)">
                              <i class="tim-icons text-warning icon-pencil mr-2"></i> Edit item category
                            </a>
                            <hr v-if="hasPermissions('inventory_update') && hasPermissions('inventory_delete')">
                            <a v-if="hasPermissions('inventory_delete')" class="dropdown-item mt-1 mb-2"  v-on:click="deleteItemCategoryPrompt(row.item)">
                              <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Delete item category
                            </a>
                          </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
<!--          Mobile-->
          <div class="d-block d-sm-none">
            <div class="row" >
              <div class="col">
                <b-table v-if="item_categories.length > 0" striped hover :items="item_categories"
                         :fields="['categories']">
                  <template v-slot:cell(categories)="row">
                    <h4 class="categories">{{row.item.name}}</h4>
                    <small>{{row.item.description}}</small>
                    <div
                      class="btn-group btn-group-toggle mt-3 mb-2"
                      :class="'float-left'"
                      data-toggle="buttons" style="width:100%"
                    >
                      <label class="btn btn-sm btn-primary btn-simple" v-if="hasPermissions('inventory_update')">
                        <base-button
                          v-on:click="editItemCategoryPrompt(row.item)"
                          type="primary"
                          class="btn btn-link"
                          size="sm"
                          icon
                        ><i class="tim-icons icon-pencil"></i>
                        </base-button>
                      </label>
                      <label class="btn btn-sm btn-primary btn-simple" v-if="hasPermissions('inventory_delete')">
                        <base-button
                          v-on:click="deleteItemCategoryPrompt(row.item)"
                          type="primary"
                          class="btn btn-link"
                          size="sm"
                          icon
                        ><i class="tim-icons icon-trash-simple"></i>
                        </base-button>
                      </label>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <b-pagination
            v-model="currentPageCategories"
            :total-rows="totalRowsCategories"
            :per-page="perPageCategories"
            v-on:input="getItemCategories(perPage, getOffset(currentPageCategories, perPageCategories))"
          ></b-pagination>
        </div>
      </card>
    </div>
  </div>

<!--Add category-->
  <modal :show.sync="modals.new_category"
         body-classes="p-0"
         modal-classes="modal-dialog-centered">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">
      <h4 v-if="category.hasOwnProperty('id')">Edit item category</h4>
      <h4 v-else>Create item category</h4>
      <div class="row" >
        <div class="col">
          <base-input :error="errs.category_name"
                      label="Category name" type="text" placeholder="Example - Merchandise" v-model="category.name"></base-input>
        </div>
      </div>
      <div class="row" >
        <div class="col">
          <base-input label="Description">
            <el-input
              v-model="category.description"
              :rows="5"
              type="textarea"
              placeholder="Category description"
            />
          </base-input>
        </div>
      </div>
      <div class="row text-center mt-3">
        <div class="col">
          <base-button  type="secondary" @click="modals.new_category = false">Cancel</base-button>
          <base-button v-if="category.hasOwnProperty('id')" class="ml-3" type="primary" @click="updateCategory()">Save</base-button>
          <base-button v-else class="ml-3" type="primary" @click="createCategory()">Save</base-button>
        </div>
      </div>
    </card>
  </modal>

  <!--Add item-->
  <base-drawer
    :show="modals.new_item"
    :title="item.hasOwnProperty('id') ? 'Edit item' : 'Create item'"
    @close="modals.new_item = false">

    <drawer-section title="Details" icon="icon-tag">
      <base-input :error="errs.item.name"
                  label="Item name" type="text" placeholder="Example - Water bottle" v-model="item.name"></base-input>
      <base-input label="Description">
        <el-input
          v-model="item.description"
          :rows="4"
          type="textarea"
          placeholder="Item description"
        />
      </base-input>
      <base-input label="Category" :error="errs.item.item_category_id">
        <el-select
          label="Select category"
          v-model="item.item_category_id"
          class="select-primary"
          value-key="id"
          placeholder="Category">
          <el-option
            v-for="(ac, i) in available_categories"
            class="select-primary"
            :label="ac.name"
            :value="{name: ac.name, id: ac.id}"
            :key="'AC' + i"
          ></el-option>
        </el-select>
      </base-input>

      <label>Item image</label>
      <div class="item-image-uploader" @click="openImageEditor">
        <div v-if="item.img && item.img.url" class="item-image-uploader__thumb" :style="{'background-color': item.img.background_color}">
          <img :src="item.img.url" :style="{'object-fit': item.img.object_fit || 'cover'}" />
        </div>
        <i v-else class="tim-icons icon-cloud-upload-94 item-image-uploader__icon"></i>
        <div class="item-image-uploader__meta">
          <span class="item-image-uploader__title text-white">{{ item.img && item.img.url ? 'Change image' : 'Upload image' }}</span>
          <span class="item-image-uploader__hint">{{ item.img && item.img.url ? 'Click to replace or reposition' : 'Click to add a photo' }}</span>
        </div>
        <button v-if="item.img && item.img.url" type="button" class="item-image-uploader__remove"
                title="Remove image" @click.stop="removeImage">
          <i class="tim-icons icon-simple-remove"></i>
        </button>
      </div>
    </drawer-section>

    <drawer-section title="Where can this be sold?" icon="icon-cart-simple">
      <div class="drawer-toggle-row">
        <el-switch active-color="#e14eca" v-model="item.sellable_external" />
        <label>Booking site (customers)</label>
      </div>
      <div class="drawer-toggle-row">
        <el-switch active-color="#e14eca" v-model="item.sellable_internal" />
        <label>Internal (staff add to a transaction)</label>
      </div>
      <info-hint v-if="!item.sellable_internal && !item.sellable_external" variant="neutral" style="width: 100%">
        <strong>Not for sale.</strong> Tracked in inventory only, for example props or supplies.
      </info-hint>

      <hr class="drawer-divider" />

      <div class="drawer-toggle-row">
        <el-switch active-color="#e14eca" v-model="item.is_addon" />
        <label>Offered as an add-on for experiences</label>
      </div>
      <base-input v-if="item.is_addon" label="Add-on for">
        <el-select
          v-model="item.addon_events"
          class="select-primary addon-events-select"
          multiple
          value-key="id"
          placeholder="Select experiences">
          <el-option
            v-for="(ae, index) in addon_events"
            class="select-primary"
            :label="ae.name"
            :value="{id: ae.id, name: ae.name}"
            :key="'AE' + index"
          ></el-option>
        </el-select>
      </base-input>
      <div v-if="item.is_addon" class="drawer-toggle-row">
        <el-switch active-color="#e14eca" v-model="item.is_addon_for_gift_cards" />
        <label>Also offer at gift-card purchase</label>
      </div>
      <info-hint v-if="item.sellable_external && !item.is_addon" variant="warning" style="width: 100%">
        To appear on the booking site it also has to be an <strong>event add-on</strong>, so turn that on and pick experiences.
      </info-hint>
      <info-hint v-if="item.is_addon" variant="primary" style="width: 100%">
        On the booking site, only the <strong>selected experiences</strong> show this add-on.
      </info-hint>
    </drawer-section>

    <drawer-section title="Pricing and availability" icon="icon-money-coins">
      <div class="mb-3">
        <label>Unit price</label>
        <money-input
          v-model="item.price"
          :error="priceErrorState"
          :currency="currency"
          :currency-symbol="currency_symbol"
          :currency-format="currency_format"
          :min="0"
          :precision="2"
          placeholder="0.00" />
      </div>
      <div class="drawer-toggle-row">
        <el-switch active-color="#e14eca" v-model="item.unlimited_available_quantity" />
        <label>Unlimited available quantity</label>
      </div>
      <base-input v-if="!item.unlimited_available_quantity" required :error="errs.item.available" class="qty-field"
                  label="Available quantity" type="number" placeholder="0">
        <el-input-number :controls="false" v-model="item.available" :min="0" :precision="0"/>
      </base-input>
      <div class="drawer-toggle-row">
        <el-switch active-color="#e14eca" v-model="item.enforce_purchase_limit" />
        <label>Enforce purchase limit</label>
      </div>
      <base-input v-if="item.enforce_purchase_limit" required class="qty-field"
                  label="Maximum purchase quantity" type="number" placeholder="0">
        <el-input-number :controls="false" v-model="item.max_purchase_quantity" :min="1" :precision="0"/>
      </base-input>
    </drawer-section>

    <template #footer>
      <div class="footer-actions">
        <base-button type="secondary" size="sm" @click="modals.new_item = false">Cancel</base-button>
        <base-button v-if="item.hasOwnProperty('id')" type="primary" size="sm" @click="updateItem()">Save</base-button>
        <base-button v-else type="primary" size="sm" @click="createItem()">Save</base-button>
      </div>
    </template>
  </base-drawer>

  <!-- ImageEditor lives OUTSIDE the drawer: opening it sets modals.new_item = false
       (hiding the drawer so the editor modal is unobstructed), which would unmount
       the editor if it were nested. The dropzone drives it via the ref. -->
  <image-editor ref="imageEditor" hide-trigger :edit="!!(item.img && item.img.url)" :edited_image="item.img"
                @closed="modals.new_item = true" @clickUpload="uploadImage" @saveImage="saveImage"></image-editor>

  <!--    Copy to other groups-->
  <modal :show.sync="modals.copy_to_groups"
         body-classes="p-0"
         modal-classes="modal-dialog-centered modal-lg">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <h4>Copy <span class="text-primary">{{item.name}}</span> to other groups</h4>

      <div class="row mb-4" v-if="groups">
        <div class="col">
          <base-input label="Select groups" :error="errs.groups">
            <el-select multiple
                       v-model="selectedGroups"
                       class="select-primary"
                       name="game"
                       placeholder="Group"
                       value-key="id"
            >
              <el-option
                v-for="(group, i) in groups"
                class="select-primary"
                :label="group.name"
                :value="{ name: group.name, id: group.id} "
                :key="'F' + i"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>

      <div class="row text-center">
        <div class="col">
          <base-button type="default" @click="modals.copy_to_groups = false">Cancel</base-button>
          <base-button type="primary" class="ml-2" @click="copyItem()">Copy</base-button>
        </div>
      </div>

    </card>
  </modal>

</div>
</template>

<script>
import {BPagination, BTable} from "bootstrap-vue";
import {Dropdown, DropdownItem, DropdownMenu, Switch} from "element-ui";
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import axios from "axios";
import swal from "sweetalert2";
import currencies from "@/assets/currencies.json";
import Badge from "@/components/Badge";
import ImageEditor from "@/components/ImageEditor";
import _ from "lodash";

export default {
  name: "InventoryManagement",
  components: {
    BTable,
    BPagination,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Switch.name]: Switch,
    Badge,
    ImageEditor
  },
  data() {
    return {
      loading: false,
      tableLoading: false,
      companyId: localStorage.getItem('companyId'),
      companyGroupId: JSON.parse(localStorage.getItem('group')).id,
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      currencies: currencies.currencies,
      number_format: JSON.parse(localStorage.getItem('group')).number_format,
      currency_symbol: '$',
      currency: JSON.parse(localStorage.getItem('group')).currency,
      currency_format: JSON.parse(localStorage.getItem('group')).currency_format,
      items: [],
      itemFields: [
        { key: 'item_name', sortable: true },
        { key: 'category', sortable: true },
        { key: 'unit_price', sortable: true },
        { key: 'available', sortable: true },
        { key: 'purchased', sortable: true },
        { key: 'purchase_limit', sortable: true },
        { key: 'availability' },
        { key: 'is_an_add-on', sortable: true },
        { key: 'actions' }
      ],
      sortBy: '',
      sortDesc: true,
      addon_events: [],
      item_categories: [],
      available_categories: [],
      perPageOptions: [5, 10, 25, 50],
      currentPage: Number(this.$route.query.page) || 1,
      perPage: Number(this.$route.query.count) || 10,
      totalRows: 10,
      totalRowsCategories: 10,
      currentPageCategories: 1,
      perPageCategories: 10,
      activeTabIndex: 0,
      j: 0,
      k: 0,
      modals: {
        new_category: false,
        new_item: false,
        copy_to_groups: false
      },
      errs: {
        category_name: '',
        groups: '',
        item: {
          name: '',
          price: '',
          available: '',
          item_category_id: ''
        }
      },
      category: {
        name: '',
        description: ''
      },
      item: {
        name: '',
        description: '',
        price: '',
        item_category_id: '',
        available: '',
        sellable_internal: true,
        sellable_external: false,
        is_addon: false,
        is_addon_for_gift_cards: false,
        image_id: null,
        img: {
          url: null,
          scale: 100,
          background_color: '#ffffff',
          x: 300,
          y: 100,
          object_fit: 'contain'
        }
      },
      groups: [],
      selectedGroups: [],
      filterValues: this.buildInitialFilterValues(),
      // FilterBar (saved-views enabled) drives the first fetch via its initial
      // `change`; this guards the page number on that first call.
      didInitialFetch: false
    }
  },
  computed: {
    categories() {
      return [
        { name: 'Items', icon: 'tim-icons icon-shape-star', active: true },
        { name: 'Item Categories', icon: 'tim-icons icon-molecule-40', active: false }
      ];
    },
    priceErrorState() {
      // Drive the MoneyInput's error border purely from the CURRENT value so a
      // stale validation flag can never leave it perpetually red. Only a present
      // but genuinely invalid (negative / non-numeric) price turns it red; empty
      // is handled by the save-time validation, not a red border.
      if (this.item.price == null || this.item.price === '') return false
      const n = Number(this.item.price)
      return (isNaN(n) || n < 0) ? 'Invalid price' : false
    },
    filterSchema() {
      return [
        { key: 'item_name', type: 'text', label: 'Item name', placeholder: 'Item name', operatorLabel: 'contains', primary: true },
        {
          key: 'category', type: 'select', label: 'Category', primary: true,
          options: (this.available_categories || []).map(c => ({ label: c.name, value: c.id }))
        },
        { key: 'unit_price', type: 'numberrange', label: 'Unit price', primary: true },
        { key: 'available', type: 'text', label: 'Available', placeholder: 'Exact quantity', operatorLabel: 'equals', primary: true },
        {
          key: 'availability', type: 'select', label: 'Sellable on', primary: true,
          options: [
            { label: 'Booking site', value: 'booking_site' },
            { label: 'Staff console', value: 'console' },
            { label: 'Not for sale', value: 'not_for_sale' }
          ]
        },
        { key: 'purchased', type: 'text', label: 'Purchased', placeholder: 'Exact quantity', operatorLabel: 'equals', primary: true }
      ];
    }
  },
  methods: {
    async copyToGroupsPrompt(item, event){
      event.preventDefault()
      this.item = item
      this.selectedGroups = []
      await this.getGroups()
      this.modals.copy_to_groups = true
    },
    async copyItem(){
      if(this.selectedGroups.length <= 0){
        this.errs.groups = 'Please select groups'
        return
      } else {
        this.errs.groups = ''
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let url = API_LOCATION + 'companies/' + this.companyId + '/groups/' + this.companyGroupId + '/inventory/' + this.item.id
      let data = {
        groups: this.selectedGroups
      }

      this.axios.put(url, data, config)
        .then(response => {
          swal('Success!', 'Item has been copied', 'success');
          this.getItems(this.perPage, this.getOffset(this.currentPage,  this.perPage))
          this.modals.copy_to_groups = false
          this.selectedGroups = []
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async getGroups(){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let url = API_LOCATION + 'companies/' + this.companyId + '/groups'

      axios.get(url, config)
        .then(response => {
          this.loading = false
          this.groups = response.data
          for(let n in this.groups){
            if(this.groups[n].id === JSON.parse(localStorage.getItem('group')).id){
              this.groups.splice(n, 1)
            }
          }
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    buildInitialFilterValues(){
      const q = this.$route.query || {}
      return {
        item_name: q.item_name || '',
        // Category options use the numeric id as their value, so seed as Number
        // for FilterBar's strict (===) active/summary matching.
        category: q.category ? Number(q.category) : '',
        availability: q.availability || '',
        unit_price: { from: q.unit_price_min || '', to: q.unit_price_max || '' },
        available: q.available || '',
        purchased: q.purchased || ''
      }
    },
    onFiltersChanged(values){
      this.filterValues = { ...this.filterValues, ...values }
      // The first change is FilterBar's initial saved-views resolution: keep the
      // page the URL restored and use the full-page load. Later changes reset to
      // page 1 with the silent inline filter-bar spinner.
      if(!this.didInitialFetch){
        this.didInitialFetch = true
        this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage))
      } else {
        // Applying a filter/view lands on page 1. Reset BEFORE computing the offset
        // (getItems' own reset happens after the offset arg is already computed, so
        // a stale/high currentPage would otherwise build an out-of-range offset).
        this.currentPage = 1
        this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage), 0, 'filter', true)
      }
    },
    onPerPageChange(n){
      this.perPage = n
      // Changing page size lands on page 1; reset before computing the offset.
      this.currentPage = 1
      this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage), 0, 'filter', true)
    },
    escapeCSVValue(value){
      if(typeof value === 'string'){
        value = value.replace(/"/g, '""')
        if(value.includes(',') || value.includes('\n')){
          value = `"${value}"`
        }
      }
      return value
    },
    async downloadCSV(){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      this.loading = true
      const items = await this.getAllItems(config, 5000)
      this.loading = false

      let csv = 'Item name,Description,Category,Unit price,Available,Purchased,Purchase limit,Sellable on,Add-on\n'
      items.forEach(row => {
        const channels = []
        if(row.sellable_external) channels.push('Booking site')
        if(row.sellable_internal) channels.push('Internal')
        const sellableOn = channels.length ? channels.join(' / ') : 'Not for sale'
        csv += [
          this.escapeCSVValue(row.name),
          this.escapeCSVValue(row.description || ''),
          this.escapeCSVValue(row.category_name || ''),
          Number(row.price).toFixed(2),
          row.unlimited_available_quantity ? 'Unlimited' : row.available,
          row.purchased,
          row.enforce_purchase_limit ? row.max_purchase_quantity : 'None',
          sellableOn,
          row.is_addon ? 'Yes' : 'No'
        ].join(',')
        csv += '\n'
      })

      const anchor = document.createElement('a')
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
      anchor.target = '_blank'
      anchor.download = 'inventory.csv'
      anchor.click()
    },
    async getAllItems(config, count){
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      const category = (this.filterValues.category === '' || this.filterValues.category == null) ? '' : this.filterValues.category
      let promises = []
      let pages = []
      let offset = 0
      while(offset <= this.totalRows){
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
          '/inventory?count=' + count + '&offset=' + offset +
          '&item_name=' + encodeURIComponent(this.filterValues.item_name) +
          '&category=' + encodeURIComponent(category) +
          '&unit_price_min=' + encodeURIComponent(this.filterValues.unit_price.from) +
          '&unit_price_max=' + encodeURIComponent(this.filterValues.unit_price.to) +
          '&available=' + encodeURIComponent(this.filterValues.available) +
          '&purchased=' + encodeURIComponent(this.filterValues.purchased) +
          '&availability=' + encodeURIComponent(this.filterValues.availability)
        promises.push(
          axios.get(url, config)
            .then(response => { pages.push(response.data.items) })
            .catch(err => {
              if(err.response && err.response.status == 401){
                this.$router.push('/forbidden')
              } else {
                swal('Error!', 'Something went wrong', 'error')
              }
            })
        )
        offset = offset + Number(count)
      }
      await Promise.all(promises)
      let arr = []
      pages.forEach(page => { arr = arr.concat(page) })
      return arr
    },
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    editItemPrompt(item){
      // Clear any stale validation errors from a previous open so a valid field
      // (e.g. unit price) doesn't show a red error border on load.
      this.errs.item = { name: '', price: '', available: '', item_category_id: '' }
      this.item = JSON.parse(JSON.stringify(item))
      // MySQL returns DECIMAL price as a string; MoneyInput's value is typed
      // Number, so coerce before it binds.
      this.item.price = this.item.price == null ? null : Number(this.item.price)
      this.item.is_addon = Boolean(this.item.is_addon)
      this.item.is_addon_for_gift_cards = Boolean(this.item.is_addon_for_gift_cards)
      this.item.sellable_internal = Boolean(this.item.sellable_internal)
      this.item.sellable_external = Boolean(this.item.sellable_external)
      this.item.addon_events = JSON.parse(this.item.addon_events)
      this.item.unlimited_available_quantity = Boolean(this.item.unlimited_available_quantity)
      this.item.enforce_purchase_limit = Boolean(this.item.enforce_purchase_limit)
      this.item.item_category_id = _.find(this.available_categories, {id: item.item_category_id})
      this.modals.new_item = true
    },
    uploadImage(event){
      this.modals.new_item = false
    },
    async saveImage(value){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/images'

      let data = {
        url: value.url,
        scale: value.scale,
        description: value.description,
        background_color: value.background_color,
        x: value.x,
        y: value.y,
        is_primary: 0,
        object_fit: value.object_fit
      }

      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.item.img = value
          this.item.image_id = response.data
          this.modals.new_item = true
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else if(err.response.status == 500){
            swal({
              title: 'Error',
              html: 'The feature has not been enabled as part of your subscription plan.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    addItem(){
      // Keep the same shape as the data default + editItemPrompt so every error
      // key is reactive. A missing `price` key here made errs.item.price get
      // added non-reactively, which left the MoneyInput stuck in its error state.
      this.errs.item = {
        name: '',
        price: '',
        available: '',
        item_category_id: ''
      }
      this.item = {
        name: '',
        addon_events: this.addon_events,
        description: '',
        price: '',
        item_category_id: '',
        available: '',
        sellable_internal: true,
        sellable_external: false,
        is_addon: false,
        is_addon_for_gift_cards: false,
        enforce_purchase_limit: false,
        unlimited_available_quantity: false,
        max_purchase_quantity: 0,
        image_id: null,
        img: {
        url: null,
          scale: 100,
          background_color: '#ffffff',
          x: 300,
          y: 100,
          object_fit: 'contain'
        }
      }
      this.modals.new_item = true
    },
    openImageEditor(){
      // Hide the drawer so the editor modal isn't stacked behind it, then drive
      // the ImageEditor (trigger hidden) via the ref. It lives outside the drawer
      // so this doesn't unmount it. @closed / saveImage reopen the drawer.
      const hasImg = this.item.img && this.item.img.url
      this.modals.new_item = false
      this.$nextTick(() => {
        if(hasImg){
          this.$refs.imageEditor.beginEdit(this.item.img)
        } else {
          this.$refs.imageEditor.uploadNew()
        }
      })
    },
    removeImage(){
      // Reset to the empty placeholder shape so the dropzone returns to its
      // upload state; null image_id so the save persists "no image".
      this.item.img = { url: null, scale: 100, background_color: '#ffffff', x: 300, y: 100, object_fit: 'contain' }
      this.item.image_id = null
    },
    deleteItemPrompt(item){
      swal({
        title: 'Are you sure?',
        text: `The item will be permanently deleted`,
        type: 'warning',
        showCancelButton: true,
      }).then((response)=> {
        if(response.value == true){
          this.deleteItem(item);
        }
      })
    },
    deleteItemCategoryPrompt(item){
      swal({
        title: 'Are you sure?',
        text: `The item category will be permanently deleted`,
        type: 'warning',
        showCancelButton: true,
      }).then((response)=> {
        if(response.value == true){
          this.deleteItemCategory(item);
        }
      })
    },
    async deleteItem(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId + '/inventory/' + item.id

      axios.delete(url, config)
        .then(response => {
          this.loading = false
          swal('Success!', 'Item has been deleted', 'success')
          this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage))
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async deleteItemCategory(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId + '/inventory/categories/' + item.id

      axios.delete(url, config)
        .then(response => {
          this.loading = false
          swal('Success!', 'Item category has been deleted', 'success')
          this.getItemCategories(this.perPageCategories, this.getOffset(this.currentPageCategories, this.perPageCategories))
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    addNewItemCategory(){
      this.category = {
        name: '',
        description: ''
      }
      this.errs.category_name = ''
      this.modals.new_category = true
    },
    switchTab(index){
      this.activeTabIndex = index
      for(let n in this.categories){
        this.categories[n].active = false
      }
      this.categories[index].active = true

      if(this.activeTabIndex === 1){
        this.getItemCategories(this.perPageCategories, this.getOffset(this.currentPageCategories, this.perPageCategories))
      }
      this.j++
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    editItemCategoryPrompt(item){
      this.category = JSON.parse(JSON.stringify(item))
      this.errs.category_name = ''
      this.modals.new_category = true
    },
    validateCategory(){
      let errors = 0

      if(this.category.name === ''){
        this.errs.category_name = "Category name cannot be empty"
        errors++
      } else {
        this.errs.category_name = ''
      }
      return errors > 0 ? false : true
    },
    validateItem(){
      let errors = 0

      if(this.item.name === ''){
        this.errs.item.name = "Item name cannot be empty"
        errors++
      } else {
        this.errs.item.name = ''
      }

      if(this.item.price === '' || this.item.price < 0 || isNaN(this.item.price)){
        this.errs.item.price = "Invalid price"
        errors++
      } else {
        this.errs.item.price = ''
      }

      if(this.item.item_category_id === '' || this.item.item_category_id === null || this.item.item_category_id === undefined){
        this.errs.item.item_category_id = "Invalid category"
        errors++
      } else {
        this.errs.item.item_category_id = ''
      }

      if(!this.item.unlimited_available_quantity && (this.item.available === '' || this.item.available < 0 || isNaN(this.item.available))){
        this.errs.item.available = "Invalid quantity"
        errors++
      } else {
        this.errs.item.available = ''
      }

      // An add-on has to be buyable somewhere — block an add-on with no channel.
      if(this.item.is_addon && !this.item.sellable_internal && !this.item.sellable_external){
        swal('Hold on', 'An add-on must be sellable on at least one channel (booking site or staff console).', 'warning')
        errors++
      }
      this.k++
      return errors > 0 ? false : true
    },
    async updateItem(item){
      if(!this.validateItem()){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId + '/inventory/' + this.item.id
      let data = {
        name: this.item.name,
        description: this.item.description,
        image_id: this.item.image_id,
        available: this.item.unlimited_available_quantity ? 0 : this.item.available,
        price: this.item.price,
        item_category_id: this.item.item_category_id.id,
        sellable_internal: this.item.sellable_internal,
        sellable_external: this.item.sellable_external,
        addon_events: this.item.addon_events,
        is_addon: this.item.is_addon,
        is_addon_for_gift_cards: this.item.is_addon_for_gift_cards,
        max_purchase_quantity: this.item.max_purchase_quantity,
        unlimited_available_quantity: this.item.unlimited_available_quantity,
        enforce_purchase_limit: this.item.enforce_purchase_limit
      }

      axios.put(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.new_item = false
          swal('Success!', 'Item has been updated', 'success')
          this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage))
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async createItem(){
      if(!this.validateItem()){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId + '/inventory'
      let data = {
        name: this.item.name,
        description: this.item.description,
        image_id: this.item.image_id,
        available: this.item.unlimited_available_quantity ? 0 : this.item.available,
        price: this.item.price,
        item_category_id: this.item.item_category_id.id,
        sellable_internal: this.item.sellable_internal,
        sellable_external: this.item.sellable_external,
        addon_events: this.item.addon_events,
        is_addon: this.item.is_addon,
        is_addon_for_gift_cards: this.item.is_addon_for_gift_cards,
        max_purchase_quantity: this.item.max_purchase_quantity,
        unlimited_available_quantity: this.item.unlimited_available_quantity,
        enforce_purchase_limit: this.item.enforce_purchase_limit
      }

      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.new_item = false
          swal('Success!', 'Item has been created', 'success')
          this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage))
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async createCategory(){
      if(!this.validateCategory()){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId + '/inventory/categories'
      let data = this.category

      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.new_category = false
          swal('Success!', 'Item category has been created', 'success')
          this.getItemCategories(this.perPageCategories, this.getOffset(this.currentPageCategories, this.perPageCategories))
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async updateCategory(){
      if(!this.validateCategory()){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId + '/inventory/categories/' + this.category.id
      let data = this.category

      axios.put(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.new_category = false
          swal('Success!', 'Item category has been updated', 'success')
          this.getItemCategories(this.perPageCategories, this.getOffset(this.currentPageCategories, this.perPageCategories))
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    onSortChanged(ctx){
      // Server-side sort: b-table only holds the current page, so reordering
      // must come from a refetch. Reset to page 1 so the new top-of-sort row
      // is visible instead of landing mid-list.
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.currentPage = 1
      // silent = true: show the local table spinner, not the full-page loader.
      this.getItems(this.perPage, this.getOffset(this.currentPage, this.perPage), 0, 'sort', true)
    },
    async getItems(count, offset, init, source, silent){
      if(source === 'filter'){
        this.currentPage = 1
      }
      let category = (this.filterValues.category === '' || this.filterValues.category == null)
        ? '' : this.filterValues.category

      if(silent){
        this.tableLoading = true
      } else {
        this.loading = true
      }
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId +
        '/inventory?count=' + count + '&offset=' + offset +
        `&item_name=` + encodeURIComponent(this.filterValues.item_name) +
          `&category=` + encodeURIComponent(category) +
        `&unit_price_min=` + encodeURIComponent(this.filterValues.unit_price.from) +
        `&unit_price_max=` + encodeURIComponent(this.filterValues.unit_price.to) +
        `&available=` + encodeURIComponent(this.filterValues.available) +
        `&purchased=` + encodeURIComponent(this.filterValues.purchased) +
        `&availability=` + encodeURIComponent(this.filterValues.availability)

      if(this.sortBy){
        url += `&sort=` + encodeURIComponent(this.sortBy) +
          `&direction=` + (this.sortDesc ? 'DESC' : 'ASC')
      }

      axios.get(url, config)
        .then(response => {
          this.loading = false
          this.tableLoading = false
          this.items = response.data.items
          this.available_categories = response.data.item_categories
          this.totalRows = response.data.totalRows

          for(let n in this.items){
            if(this.items[n].img){
              this.items[n].img = JSON.parse(this.items[n].img)[0]
            } else {
              // No image: leave url null so the table renders a clean icon tile
              // (and the edit drawer shows its upload dropzone) instead of a
              // stock placeholder photo.
              this.items[n].img = {
                url: null,
                scale: 100,
                background_color: '#ffffff',
                x: 300,
                y: 100,
                object_fit: 'contain'
              }
            }

            this.items[n].image_id = this.items[n].img.id
          }

          this.addQueryParameters()
        })
        .catch(err => {
          this.loading = false
          this.tableLoading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async getItemCategories(count, offset){
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'  + companyId + '/groups/' + companyGroupId +
        '/inventory/categories?count=' + count + '&offset=' + offset

      axios.get(url, config)
        .then(response => {
          this.loading = false
          this.item_categories = response.data.item_categories
          this.totalRowsCategories = response.data.totalRows
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    addQueryParameters() {
      this.$nextTick(() => {
        this.currentPage = this.$route.query.page
      });

      const newQuery = {
        ...this.$route.query,
        count: this.perPage,
        page: this.currentPage,
        item_name: this.filterValues.item_name,
        unit_price_min: this.filterValues.unit_price.from,
        unit_price_max: this.filterValues.unit_price.to,
        available: this.filterValues.available,
        purchased: this.filterValues.purchased,
        availability: this.filterValues.availability,
        category: this.filterValues.category,

    }
      this.$router.replace({query: newQuery}).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    getAmount(integer) {
      if (integer == null) {
        return;
      }

      // Get currency info
      const currencyInfo = _.find(this.currencies, { code: this.currency });
      const symbol = currencyInfo ? currencyInfo.symbol : this.currency_symbol;
      const isPostfix = currencyInfo ? currencyInfo.postfix : false;

      let formattedAmount;

      if (this.number_format === 1) {
        // European formatting (comma as decimal separator)
        formattedAmount = integer.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
      } else {
        // Standard formatting (dot as decimal separator)
        formattedAmount = parseFloat(integer).toFixed(2);
      }

      if (this.currency_format === 0) {
        // Symbol format
        if (isPostfix) {
          return formattedAmount + symbol;  // 12.34kr
        } else {
          return symbol + formattedAmount;  // $12.34
        }
      } else {
        // Currency code format
        return formattedAmount + ' ' + this.currency;  // 12.34 SEK
      }
    },
    getOffset(currentPage, perPage){
      // Clamp to >= 0. currentPage can be NaN/0 transiently (e.g. arriving from a
      // saved-view drawer link with no ?page, before mounted defaults it), which
      // would otherwise send a negative offset and 502 the backend (SQL parse error).
      const page = Number(currentPage) || 1
      return Math.max(0, (page * Number(perPage || 0)) - Number(perPage || 0))
    },
    async getGames () {
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/games'
      this.axios.get(url, config)
        .then(response => {
          this.addon_events = response.data
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
  },
  watch: {
    // BaseDrawer doesn't handle ESC; each consumer wires its own listener
    // (canonical pattern, e.g. BookingSlotSettingsDrawer.vue).
    'modals.new_item'(val) {
      if (val) {
        document.addEventListener('keydown', this._onEscKey)
      } else {
        document.removeEventListener('keydown', this._onEscKey)
      }
    },
    // Clear the price error as the user edits, otherwise a validation error
    // sticks on MoneyInput until the next Save (perpetual error state).
    'item.price'() {
      if (this.errs && this.errs.item) this.errs.item.price = ''
    }
  },
  created() {
    this._onEscKey = (e) => {
      if (e.key === 'Escape') this.modals.new_item = false
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._onEscKey)
  },
  mounted() {
    this.currency_symbol =  _.find(this.currencies, { code: JSON.parse(localStorage.getItem('group')).currency }).symbol
    // Default when the query omits count/page (e.g. navigating in from a saved view
    // with only ?view=), otherwise Number(undefined) => NaN builds a bad fetch URL.
    this.perPage = Number(this.$route.query.count) || 10
    this.currentPage = Number(this.$route.query.page) || 1
    if (this.$route.query.tab !== undefined) {
      this.switchTab(Number(this.$route.query.tab))
    }
    this.getGames()
    // FilterBar owns the initial applied filter state (saved-views precedence) and
    // emits one initial `change` that drives the first getItems — see onFiltersChanged.
    // Show the loading overlay until that lands.
    this.loading = true
  }
}
</script>

<style scoped>
.item-thumb {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  object-fit: cover;
  float: left;
  margin: 0 10px 0 5px;
}
.item-thumb--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(125, 125, 125, 0.12);
  border: 1px solid rgba(125, 125, 125, 0.2);
}
.item-thumb--empty i {
  font-size: 18px;
  color: rgba(140, 140, 160, 0.8);
}

/* bootstrap-vue's own CSS (which draws the sort carets) isn't imported in this
   app, so sortable headers had no visible affordance. Render our own caret +
   pointer on the th[aria-sort] elements b-table sets on sortable columns. */
::v-deep table.b-table thead th[aria-sort] {
  cursor: pointer;
  position: relative;
  padding-right: 1.25rem;
  user-select: none;
}
::v-deep table.b-table thead th[aria-sort]::after {
  content: "";
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid rgba(125, 125, 125, 0.55);
}
::v-deep table.b-table thead th[aria-sort="ascending"]::after {
  border-top: none;
  border-bottom: 5px solid #e14eca;
}
::v-deep table.b-table thead th[aria-sort="descending"]::after {
  border-top: 5px solid #e14eca;
  border-bottom: none;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.drawer-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
}
.drawer-toggle-row label {
  margin-bottom: 0;
}
.drawer-divider {
  border: none;
  border-top: 1px solid rgba(125, 125, 125, 0.2);
  margin: 14px 0;
}
/* Element UI textareas default to a white background — darken the description
   field to match the rest of the dark drawer (light mode below). */
::v-deep .el-textarea__inner {
  background: rgba(30, 30, 47, 0.6);
  color: #fff;
  border: 1px solid rgba(225, 78, 202, 0.4);
}
::v-deep .el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.4);
}
.white-content ::v-deep .el-textarea__inner {
  background: #fff;
  color: #344675;
  border-color: rgba(0, 0, 0, 0.15);
}
/* Cap the add-on multiselect so a large seeded list scrolls instead of
   consuming half the drawer. */
::v-deep .addon-events-select .el-select__tags {
  max-height: 120px;
  overflow-y: auto;
  padding-right: 4px;
}
/* Hide the dropdown chevron on the add-on multiselect: with the scrollable tag
   area its caret sat awkwardly beside the scrollbar. Clicking/typing still opens
   the options. Reclaim the suffix space so the scrollbar meets the right edge. */
::v-deep .addon-events-select .el-select__caret {
  display: none;
}
::v-deep .addon-events-select .el-input__suffix {
  width: 0;
}
/* MoneyInput's resting border is an always-on magenta that reads as a
   perpetual error next to the neutral fields here. Keep it neutral at rest;
   magenta on focus; red only for a real validation error. */
::v-deep .amount-input-group {
  border-color: rgba(125, 125, 125, 0.35) !important;
}
::v-deep .amount-input-group:focus-within {
  border-color: #e14eca !important;
}
::v-deep .amount-input-group.has-error {
  border-color: #ec250d !important;
}
/* Left-align the quantity inputs so they line up with the unit price (which is
   left-aligned) instead of el-input-number's default centered value. */
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
/* A count doesn't need the full drawer width — keep the quantity inputs compact
   (constrain the input only, so the label still reads on one line). */
.qty-field ::v-deep .el-input-number {
  width: 180px;
  max-width: 100%;
}
/* Clickable image dropzone (mirrors the tickets-page upload aesthetic). */
.item-image-uploader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px dashed rgba(125, 125, 125, 0.35);
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.item-image-uploader:hover {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.05);
}
.item-image-uploader__thumb {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}
.item-image-uploader__thumb img {
  width: 100%;
  height: 100%;
}
.item-image-uploader__icon {
  font-size: 22px;
  color: #e14eca;
  width: 48px;
  text-align: center;
  flex-shrink: 0;
}
.item-image-uploader__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.item-image-uploader__title {
  font-size: 13px;
  font-weight: 600;
}
.item-image-uploader__hint {
  font-size: 11px;
  color: rgba(140, 140, 160, 0.9);
}
.item-image-uploader__remove {
  margin-left: auto;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(125, 125, 125, 0.12);
  border: none;
  border-radius: 6px;
  color: rgba(140, 140, 160, 0.9);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.item-image-uploader__remove:hover {
  background: rgba(253, 93, 147, 0.15);
  color: #fd5d93;
}
.item-image-uploader__remove i {
  font-size: 12px;
}
</style>
